import axios from "axios";
import { API_URL } from "../const";

export const fetchAmenitiesLists = async () => {
  return axios
    .get(`${API_URL}/coworking/unit-amenity-list`)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(error.message);
    });
};

export const deleteAmenitiesList = async (id) => {
  return axios
    .delete(`${API_URL}/coworking/unit-amenity-list/${id}`)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(error.message);
    });
};

export const addAmenitiesList = async (data) => {
  return axios
    .post(`${API_URL}/coworking/unit-amenity-list`, data)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(error.message);
    });
};

export const getAmenitiesList = async (id) => {
  try {
    const response = await axios.get(`${API_URL}/coworking/unit-amenity-list/${id}`);
    return response.data;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const editAmenitiesList = async (id, data) => {
  try {
    const response = await axios.put(`${API_URL}/coworking/unit-amenity-list/${id}`, data);
    return response.data;
  } catch (error) {
    throw new Error(error.message);
  }
};
